
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34580',
  depVersions: {
  "documents-public-ui": "static-1.34580",
  "atom": "static-1.5096",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2522",
  "client-types": "static-1.468",
  "cssUtils": "static-1.798",
  "customer-data-filters-ui": "static-1.39887",
  "customer-data-objects": "static-1.7697",
  "customer-data-property-utils": "static-1.8114",
  "documents-lib": "static-1.34585",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85921",
  "FormUrlGenerator": "static-2.4742",
  "foundations-theming-specialty": "static-1.2160",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5614",
  "hs-test-utils": "static-1.8037",
  "hub-http": "static-1.6245",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11803",
  "HubStyleTokens": "static-2.11496",
  "I18n": "static-7.1631",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3045",
  "jasmine-runner": "static-1.6487",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7179",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5423",
  "quartz": "static-1.7062",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16695",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5362",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8194",
  "reference-resolvers-lite": "static-1.8118",
  "reporting-data": "static-1.67660",
  "reporting-reports": "static-1.67338",
  "reporting-snowflake": "static-1.56278",
  "reporting-testing-lib": "static-1.9593",
  "reporting-visualizations": "static-1.59736",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8966",
  "sanitize": "static-1.4500",
  "sanitize-text": "static-1.8166",
  "self-service-api": "static-1.10271",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1771",
  "signup-constants": "static-1.18886",
  "signup-ui-url-generator": "static-2.8076",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4785",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4787",
  "ui-addon-form-validation": "static-1.11014",
  "ui-asset-management-lib": "static-1.11068",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8442",
  "usage-tracker": "static-1.7371",
  "usage-tracker-container": "static-1.7361",
  "usage-tracker-core": "static-1.7221",
  "viral-links-lib": "static-1.7090",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9691",
  "foundations-components": "static-1.7983",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.840",
  "quartz-core": "static-1.6281",
  "quick-fetch": "static-1.3934",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4676",
  "ui-addon-i18n": "static-1.11172",
  "ui-addon-upgrades": "static-9.18032",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3417",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3339",
  "quartz-webpack": "static-1.3286",
  "foundations-assets": "static-1.4892",
  "foundations-theming": "static-1.4444",
  "hub-http-shared-msw-handlers": "static-1.10022",
  "hubspotter-http": "static-1.4669",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.247",
  "conversations-skeleton-state": "static-1.7271",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22322",
  "customer-data-objects-ui-components": "static-1.13052",
  "customer-data-reference-ui-components": "static-1.13189",
  "customer-data-ui-utilities": "static-1.9850",
  "framework-builder-read-service-client": "static-1.4023",
  "framework-data-schema-quick-fetch": "static-1.6813",
  "framework-data-schema-resolvers": "static-1.6908",
  "inbound-db-meta-service-client": "static-1.3604",
  "inbound-db-properties-service-client": "static-1.3864",
  "multi-account-reference-resolvers": "static-1.1003",
  "onboarding-tours": "static-1.16658",
  "reporting-datasets-permissions-lib": "static-1.13754",
  "ui-addon-teams": "static-1.21589",
  "quartz-auth": "static-1.737",
  "ui-business-units-lib": "static-1.9079",
  "usage-tracker-session-replay": "static-1.5057",
  "ai-components-ui-library": "static-1.9035",
  "ContentUtils": "static-1.68437",
  "customer-data-properties": "static-1.51646",
  "forms-ai-lib": "static-1.4354",
  "forms-utils-lib": "static-1.12629",
  "foundations-components-test-utils": "static-1.5466",
  "react-dnd-compat": "static-1.4638",
  "react-tinymce": "static-1.55311",
  "tinymce-config": "static-2.54437",
  "ui-gdpr-components": "static-1.10374",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3429",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3148",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.98",
  "ui-fonts": "static-1.758",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4351",
  "csstype": "static-1.50",
  "quartz-head": "static-1.727",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1565",
  "external-options-client-types": "static-1.4177",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.737",
  "frontend-preferences-client": "static-1.7951",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3722",
  "reporting-client-types": "static-1.2500",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25450",
  "hubspot-apollo-client": "static-1.4903",
  "foundations-components-legacy": "static-1.1008",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.492",
  "hs-story-utils": "static-1.9448",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.250",
  "timezone-utils": "static-2.5268",
  "seat-types-lib": "static-1.66",
  "bend-plugin-foundations-components": "static-1.4252",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2023",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.737",
  "quartz-tracking": "static-1.441",
  "bend-plugin-chirp-manifest": "static-1.86",
  "chirp-fetch": "static-1.1911",
  "purchase-motions-components": "static-1.5961",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4098",
  "bender-build-tools": "static-1.3215",
  "bend-plugin-foundations-theming": "static-1.2927",
  "stylex": "static-1.33",
  "hs-resources": "static-1.177",
  "pulse": "static-1.601",
  "restore-request-side-panel-lib": "static-1.946",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3815",
  "crm-pipelines-api-client-types": "static-1.4157",
  "fdsr-migration-layer": "static-1.27",
  "multi-currency-client-types": "static-1.3709",
  "getting-started-shared-tasks": "static-1.18520",
  "growth-data-modal": "static-1.5464",
  "growth-onboarding-confetti": "static-1.3090",
  "growth-onboarding-next-action-utils": "static-1.1990",
  "navigation-components": "static-1.18110",
  "onboarding-tours-client": "static-1.4872",
  "onboarding-tours-utils": "static-1.724",
  "ui-shepherd-react": "static-3.10194",
  "ui-shepherd-tracker": "static-1.7575",
  "ui-universal-auth": "static-1.9006",
  "user-context": "static-1.5129",
  "hubspotter-http-shared-msw-handlers": "static-1.10020",
  "magpie-lib": "static-1.5566",
  "navigation-messaging": "static-1.7437",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21412",
  "copilot-toolkit": "static-1.11197",
  "cms-field-types": "static-1.4836",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16234",
  "calling-global-api": "static-1.64596",
  "calling-internal-common": "static-1.31326",
  "calling-lifecycle-internal": "static-1.65978",
  "calling-lifecycle-messages": "static-1.58272",
  "commerce-products-lib": "static-1.9656",
  "crm-links": "static-1.6318",
  "customer-data-properties-shared-msw-handlers": "static-1.9349",
  "file-manager-components": "static-1.23688",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4241",
  "meetings-icalendar-utils-lib": "static-1.655",
  "object-builder-ui-client": "static-1.48825",
  "pipeline-validation-client-types": "static-1.3983",
  "property-value-citations": "static-1.2260",
  "smart-property-lib": "static-1.7209",
  "tiered-pricing": "static-1.1270",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9083",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19873",
  "tinymce-themes": "static-1.56407",
  "data-token-picker": "static-1.16447",
  "hub-http-contrib": "static-1.3066",
  "interframe": "static-3.4783",
  "tinymce-data": "static-1.40522",
  "tinymce-plugins": "static-1.57551",
  "ui-addon-sales-email": "static-1.5234",
  "onboarding-scopes": "static-1.6485",
  "ui-addon-opt": "static-4.8388",
  "apollo-link-hub-http": "static-2.4675",
  "hubspot-apollo-cache": "static-1.362",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.196",
  "purchase-motions-api": "static-1.5964",
  "bend-plugin-pulse": "static-1.104",
  "directed-graph": "static-1.959",
  "event-emitter": "static-1.971",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1993",
  "growth-onboarding-next-action-components": "static-1.2018",
  "user-context-client": "static-1.4636",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5026",
  "nest": "static-1.253",
  "reactive-lib": "static-1.747",
  "simple-logging-lib": "static-1.3074",
  "unified-auth-core-lib": "static-1.802",
  "getting-started-shared-tasks-store": "static-1.17638",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13649",
  "integrations-tracking-lib": "static-1.5625",
  "native-integrations-shared-strings": "static-1.7805",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10390",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.520",
  "calling-error-reporting": "static-1.31333",
  "shared-worker-versioning": "static-1.11060",
  "calling-usage-tracker": "static-1.6565",
  "voice-sms-access-library": "static-1.1080",
  "customer-data-tracking": "static-1.6913",
  "commerce-permissions": "static-1.793",
  "products-iframe-lib": "static-1.8005",
  "products-ui-components-shared-msw-handlers": "static-1.10405",
  "location-customization-utils-lib": "static-1.9336",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4177",
  "video-components-external": "static-1.11353",
  "video-data-lib": "static-1.35011",
  "data-agent-kit": "static-1.231",
  "feedback-loader": "static-1.29338",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10106",
  "fsm": "static-1.3755",
  "policy-lib": "static-1.6801",
  "react-colorpicker": "static-2.10231",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10169",
  "FileManagerLib": "static-1.39328",
  "NamespacedHubStyle": "static-2.9076",
  "FileManagerCore": "static-1.39187",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7787",
  "layout-dnd-components": "static-1.12490",
  "layout-dnd-utils": "static-1.11465",
  "react-codemirror": "static-1.10650",
  "ui-addon-emoji-picker": "static-1.9912",
  "ui-brand-identity-lib": "static-1.15377",
  "InboxConnectUtils": "static-4.14883",
  "meetings-connect-utils-lib": "static-1.7629",
  "universal-page-editor-lib": "static-1.3037",
  "google-sheets-integration-lib": "static-1.312",
  "microsoft-drive-integration-lib": "static-1.444",
  "slack-ui-library": "static-1.10416",
  "calling-orchestration-schema": "static-1.35857",
  "sales-views-client-types": "static-1.4283",
  "crm-record-cards-service-types": "static-1.3615",
  "content-media-composition-data-lib": "static-1.12397",
  "content-media-compositions": "static-2.16404",
  "media-bridge-lib": "static-1.18966",
  "trellis-story-utils": "static-1.4539",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5950",
  "FileManagerImages": "static-1.36839",
  "video-components": "static-1.13356",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4560",
  "video-embed": "static-1.35845",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8726",
  "ui-coaching-tips": "static-1.28630",
  "ContentData": "static-1.68512",
  "layout-data-lib": "static-1.9790",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22183",
  "outpost": "static-1.4203",
  "growth-onboarding-feedback-components": "static-1.6604",
  "advanced-menus-core": "static-1.15164",
  "advanced-menus-lib": "static-1.12102",
  "ExportDialog": "static-6.10408",
  "ui-memberships-settings-lib": "static-1.34115",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15163",
  "simple-menus-lib": "static-1.16680"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34580",
  "atom": "/atom/static-1.5096",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2522",
  "client-types": "/client-types/static-1.468",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39887",
  "customer-data-objects": "/customer-data-objects/static-1.7697",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8114",
  "documents-lib": "/documents-lib/static-1.34585",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85921",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4742",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2160",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5614",
  "hs-test-utils": "/hs-test-utils/static-1.8037",
  "hub-http": "/hub-http/static-1.6245",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11803",
  "HubStyleTokens": "/HubStyleTokens/static-2.11496",
  "I18n": "/I18n/static-7.1631",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3045",
  "jasmine-runner": "/jasmine-runner/static-1.6487",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7179",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5423",
  "quartz": "/quartz/static-1.7062",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16695",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5362",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8194",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8118",
  "reporting-data": "/reporting-data/static-1.67660",
  "reporting-reports": "/reporting-reports/static-1.67338",
  "reporting-snowflake": "/reporting-snowflake/static-1.56278",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9593",
  "reporting-visualizations": "/reporting-visualizations/static-1.59736",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8966",
  "sanitize": "/sanitize/static-1.4500",
  "sanitize-text": "/sanitize-text/static-1.8166",
  "self-service-api": "/self-service-api/static-1.10271",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1771",
  "signup-constants": "/signup-constants/static-1.18886",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8076",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4785",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4787",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11014",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11068",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8442",
  "usage-tracker": "/usage-tracker/static-1.7371",
  "usage-tracker-container": "/usage-tracker-container/static-1.7361",
  "usage-tracker-core": "/usage-tracker-core/static-1.7221",
  "viral-links-lib": "/viral-links-lib/static-1.7090",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9691",
  "foundations-components": "/foundations-components/static-1.7983",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.840",
  "quartz-core": "/quartz-core/static-1.6281",
  "quick-fetch": "/quick-fetch/static-1.3934",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4676",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11172",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18032",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3417",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3339",
  "quartz-webpack": "/quartz-webpack/static-1.3286",
  "foundations-assets": "/foundations-assets/static-1.4892",
  "foundations-theming": "/foundations-theming/static-1.4444",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10022",
  "hubspotter-http": "/hubspotter-http/static-1.4669",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.247",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7271",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22322",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13052",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13189",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9850",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4023",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6813",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6908",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3604",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3864",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1003",
  "onboarding-tours": "/onboarding-tours/static-1.16658",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13754",
  "ui-addon-teams": "/ui-addon-teams/static-1.21589",
  "quartz-auth": "/quartz-auth/static-1.737",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9079",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5057",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ContentUtils": "/ContentUtils/static-1.68437",
  "customer-data-properties": "/customer-data-properties/static-1.51646",
  "forms-ai-lib": "/forms-ai-lib/static-1.4354",
  "forms-utils-lib": "/forms-utils-lib/static-1.12629",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5466",
  "react-dnd-compat": "/react-dnd-compat/static-1.4638",
  "react-tinymce": "/react-tinymce/static-1.55311",
  "tinymce-config": "/tinymce-config/static-2.54437",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10374",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3429",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3148",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.98",
  "ui-fonts": "/ui-fonts/static-1.758",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4351",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.727",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1565",
  "external-options-client-types": "/external-options-client-types/static-1.4177",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.737",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7951",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3722",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25450",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4903",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1008",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.492",
  "hs-story-utils": "/hs-story-utils/static-1.9448",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.250",
  "timezone-utils": "/timezone-utils/static-2.5268",
  "seat-types-lib": "/seat-types-lib/static-1.66",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4252",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2023",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.737",
  "quartz-tracking": "/quartz-tracking/static-1.441",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.86",
  "chirp-fetch": "/chirp-fetch/static-1.1911",
  "purchase-motions-components": "/purchase-motions-components/static-1.5961",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4098",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2927",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.177",
  "pulse": "/pulse/static-1.601",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.946",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3815",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4157",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.27",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3709",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18520",
  "growth-data-modal": "/growth-data-modal/static-1.5464",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3090",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1990",
  "navigation-components": "/navigation-components/static-1.18110",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4872",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.724",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10194",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7575",
  "ui-universal-auth": "/ui-universal-auth/static-1.9006",
  "user-context": "/user-context/static-1.5129",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10020",
  "magpie-lib": "/magpie-lib/static-1.5566",
  "navigation-messaging": "/navigation-messaging/static-1.7437",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "copilot-toolkit": "/copilot-toolkit/static-1.11197",
  "cms-field-types": "/cms-field-types/static-1.4836",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16234",
  "calling-global-api": "/calling-global-api/static-1.64596",
  "calling-internal-common": "/calling-internal-common/static-1.31326",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65978",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58272",
  "commerce-products-lib": "/commerce-products-lib/static-1.9656",
  "crm-links": "/crm-links/static-1.6318",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9349",
  "file-manager-components": "/file-manager-components/static-1.23688",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4241",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.655",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48825",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3983",
  "property-value-citations": "/property-value-citations/static-1.2260",
  "smart-property-lib": "/smart-property-lib/static-1.7209",
  "tiered-pricing": "/tiered-pricing/static-1.1270",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9083",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19873",
  "tinymce-themes": "/tinymce-themes/static-1.56407",
  "data-token-picker": "/data-token-picker/static-1.16447",
  "hub-http-contrib": "/hub-http-contrib/static-1.3066",
  "interframe": "/interframe/static-3.4783",
  "tinymce-data": "/tinymce-data/static-1.40522",
  "tinymce-plugins": "/tinymce-plugins/static-1.57551",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5234",
  "onboarding-scopes": "/onboarding-scopes/static-1.6485",
  "ui-addon-opt": "/ui-addon-opt/static-4.8388",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4675",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.362",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.196",
  "purchase-motions-api": "/purchase-motions-api/static-1.5964",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.104",
  "directed-graph": "/directed-graph/static-1.959",
  "event-emitter": "/event-emitter/static-1.971",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1993",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2018",
  "user-context-client": "/user-context-client/static-1.4636",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5026",
  "nest": "/nest/static-1.253",
  "reactive-lib": "/reactive-lib/static-1.747",
  "simple-logging-lib": "/simple-logging-lib/static-1.3074",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.802",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17638",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13649",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5625",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7805",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10390",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.520",
  "calling-error-reporting": "/calling-error-reporting/static-1.31333",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11060",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6565",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1080",
  "customer-data-tracking": "/customer-data-tracking/static-1.6913",
  "commerce-permissions": "/commerce-permissions/static-1.793",
  "products-iframe-lib": "/products-iframe-lib/static-1.8005",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10405",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9336",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4177",
  "video-components-external": "/video-components-external/static-1.11353",
  "video-data-lib": "/video-data-lib/static-1.35011",
  "data-agent-kit": "/data-agent-kit/static-1.231",
  "feedback-loader": "/feedback-loader/static-1.29338",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10106",
  "fsm": "/fsm/static-1.3755",
  "policy-lib": "/policy-lib/static-1.6801",
  "react-colorpicker": "/react-colorpicker/static-2.10231",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10169",
  "FileManagerLib": "/FileManagerLib/static-1.39328",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9076",
  "FileManagerCore": "/FileManagerCore/static-1.39187",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7787",
  "layout-dnd-components": "/layout-dnd-components/static-1.12490",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11465",
  "react-codemirror": "/react-codemirror/static-1.10650",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9912",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15377",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14883",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7629",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3037",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.312",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
  "slack-ui-library": "/slack-ui-library/static-1.10416",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35857",
  "sales-views-client-types": "/sales-views-client-types/static-1.4283",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12397",
  "content-media-compositions": "/content-media-compositions/static-2.16404",
  "media-bridge-lib": "/media-bridge-lib/static-1.18966",
  "trellis-story-utils": "/trellis-story-utils/static-1.4539",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5950",
  "FileManagerImages": "/FileManagerImages/static-1.36839",
  "video-components": "/video-components/static-1.13356",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4560",
  "video-embed": "/video-embed/static-1.35845",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8726",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28630",
  "ContentData": "/ContentData/static-1.68512",
  "layout-data-lib": "/layout-data-lib/static-1.9790",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22183",
  "outpost": "/outpost/static-1.4203",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6604",
  "advanced-menus-core": "/advanced-menus-core/static-1.15164",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12102",
  "ExportDialog": "/ExportDialog/static-6.10408",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34115",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15163",
  "simple-menus-lib": "/simple-menus-lib/static-1.16680"
}
};
